import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./status.module.scss";

export function CompletedStatusComplex() {
  const { t } = useTranslation();

  return (
    <Pill
      styleName="completedStatus"
      Lefticon={<img src="../../../assets/images/svg/done.svg" />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_contract_details_completed_state_complex_title")}
      </p>
    </Pill>
  );
}
